var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNumber } from "class-validator";
import { isPromise } from "./utils";
export class ResultError {
    constructor(error) {
        this.error = error;
    }
}
export function err(error) {
    return new ResultError(error);
}
export function isErr(result) {
    if (isPromise(result))
        throw new Error("Promise passed to isErr(), this is probably a mistake");
    return result instanceof ResultError;
}
export function isOk(result) {
    if (isPromise(result))
        throw new Error("Promise passed to isOK(), this is probably a mistake");
    return !(result instanceof ResultError);
}
export function voidResult() {
    return undefined;
}
export class ApiResult {
    constructor(pkg, errors) {
        this.pkg = pkg;
        this.errors = errors;
    }
    errorMessage() {
        return this.errors ? this.errors.join(", ") : null;
    }
}
export class ApiPaginationInput {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], ApiPaginationInput.prototype, "page", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], ApiPaginationInput.prototype, "pageSize", void 0);
